module.exports = __webpack_public_path__ + "static/media/  (59).b0847d75.jpg";